module.exports = __webpack_public_path__ + "static/media/meal.8522e0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/meal.png
// module id = 667
// module chunks = 1